"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mappers_1 = require("./mappers");
var utils_1 = require("../utils");
exports.productMapper = function (item) {
    return __assign({ _id: item.id, name: item.name, description: item.description }, mappers_1.mediaMapper(item.media), { sku: item.sku, ribbons: item.ribbons, currency: item.price.currency, price: item.price.price, discountedPrice: item.price.discountedPrice, formattedPrice: item.price.formatted.price, formattedDiscountedPrice: item.price.formatted.discountedPrice, trackInventory: item.stock.trackInventory, inStock: item.stock.inStock, quantityInStock: item.stock.quantity, additionalInfoSections: item.additionalInfoSections, productOptions: (item.productOptions || []).reduce(function (options, option) {
            var _a;
            return Object.assign(options, (_a = {},
                _a[option.name] = __assign({}, utils_1.omitMedia(option), { choices: option.choices.map(function (choice) { return (__assign({}, utils_1.omitMedia(choice), mappers_1.mediaMapper(choice.media))); }) }),
                _a));
        }, {}), productPageUrl: item.productPageUrl.path, customTextFields: item.customTextFields, manageVariants: item.manageVariants, productType: item.productType, slug: item.slug, weight: item.weight });
};
//# sourceMappingURL=product.mapper.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixstores-platform-common/dist/src/products/product.mapper.js
// module id = 13
// module chunks = 0